export const Unicode = {
  NonBreakingSpace: '\u00a0',
  ZeroWidthSpace: '\u200b',
};
